import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPencilIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 3.14378C12.0004 3.06482 11.9853 2.98655 11.9555 2.91345C11.9256 2.84035 11.8816 2.77387 11.826 2.71781L9.28199 0.173997C9.22593 0.118392 9.15944 0.0744005 9.08634 0.044544C9.01324 0.0146874 8.93496 -0.000446474 8.856 1.00278e-05C8.77703 -0.000446474 8.69875 0.0146874 8.62565 0.044544C8.55255 0.0744005 8.48606 0.118392 8.43 0.173997L6.732 1.87187L0.17401 8.42938C0.118401 8.48544 0.0744059 8.55192 0.0445472 8.62502C0.0146885 8.69812 -0.000446507 8.77639 1.00286e-05 8.85535V11.3992C1.00286e-05 11.5583 0.063224 11.7109 0.175746 11.8234C0.288267 11.9359 0.440879 11.9991 0.600009 11.9991H3.144C3.22796 12.0037 3.31194 11.9906 3.3905 11.9606C3.46905 11.9306 3.54043 11.8845 3.6 11.8251L10.122 5.26762L11.826 3.59974C11.8808 3.54159 11.9254 3.47467 11.958 3.40176C11.9638 3.35393 11.9638 3.30559 11.958 3.25777C11.9608 3.22984 11.9608 3.2017 11.958 3.17377L12 3.14378ZM2.89801 10.7992H1.20001V9.10133L7.158 3.14378L8.856 4.84165L2.89801 10.7992ZM9.70199 3.99571L8.004 2.29784L8.856 1.4519L10.548 3.14378L9.70199 3.99571Z",
		fill: "#CCCCDC",
		fillOpacity: .65
	})
});
export { SvgPencilIcon as ReactComponent };
